import React from 'react';

function Card({editable, color, index, content, editContent}) {

    return(
        <div className={"card " + color}>
            <textarea 
                className="content" 
                disabled={editable ? "":"disabled"} 
                value={content} 
                onChange={editContent(index, color)} 
            />
            <i className={editable ? "fa fa-trash-o delete": "hide"} aria-hidden="true" onClick={editContent(index,color,true)}></i>
        </div>
    )
}

export default Card;